import * as React from "react";
import { IWizardFormProps } from "../../../components/Wizard";
import { AdvancedEmailWizardContext } from "../../../context/AdvancedEmailWizardContext";
import { WizardTypeEnum } from "../../../enums/WizardTypeEnum";
import { strings } from "../../../localisation";
import { IParticipantEmailDataModel } from "../../EmailWizard/models/ParticipantEmail";
import { ISendEmailDataModel } from "../../EmailWizard/models/SendEmail";
import { ITemplateDataModel } from "../../TemplateWizard/models/Template";
import { ExecuteModel } from "../ExecuteModel";
import { PreviewDiv, SummaryPanelDiv } from "./Preview.styles";
import { PreviewPanel } from "./PreviewPanel/PreviewPanel";
import { ISummaryProps, SummaryPanel } from "./SummaryPanel/SummaryPanel";

export const Preview = React.memo(({ IsShown, FormikProps }: IWizardFormProps<ExecuteModel<ITemplateDataModel | ISendEmailDataModel>>) => {

    // Context
    const advancedEmailWizardContext = React.useContext(AdvancedEmailWizardContext);

    const [summaryData, setSummaryData] = React.useState<ISummaryProps>({
        SummaryTitle: advancedEmailWizardContext.WizardType === WizardTypeEnum.Template ? strings.Label_Summary_TemplateDetails : strings.Label_Summary_EmailDetails,
        TemplateName: FormikProps!.values.formDataModel.TemplateName || undefined,
        EmailName: "",
        RecipientCount: 0,
        ToAddressTypeStrings: [],
        CCAddressTypeStrings: [],
        CCFirstOnly: false,
        EmailCC: false,
        BCCAddressTypeStrings: [],
        BCCFirstOnly: false,
        EmailBCC: false,
        Subject: "",
        ViewOnPortal: false,
        CopyToCorrespondence: false,
        FromDescription: "",
        FromAddress: "",
    });

    React.useEffect(() => {
        // Set the summary data
        let fromDesc: string = "";
        let fromAddress: string = "";

        if (FormikProps && FormikProps.values.formDataModel.EmailFromItem) {
            if (advancedEmailWizardContext?.AddressTypes) {
                const from = advancedEmailWizardContext.AddressTypes.fromAddresses.find(
                    (a) => Number(a.id) === Number(FormikProps.values.formDataModel.EmailFromItem!.value),
                );
                if (from) {
                    fromDesc = from.description;
                    fromAddress = from.fromAddress;
                }
            }
        }

        // Determine recipient count
        let recipientCount: number = FormikProps!.values.ids?.length || 0;
        if (advancedEmailWizardContext.WizardType === WizardTypeEnum.Participant) {
            const participantModel = FormikProps!.values.formDataModel as IParticipantEmailDataModel;
            if (participantModel?.ParticipantEntryIDs) {
                recipientCount = participantModel.ParticipantEntryIDs.length;
            }
        }

        setSummaryData({
            ...summaryData,
            SummaryTitle: advancedEmailWizardContext.WizardType === WizardTypeEnum.Template ? strings.Label_Summary_TemplateDetails : strings.Label_Summary_EmailDetails,
            TemplateName: FormikProps!.values.formDataModel.TemplateName || undefined,
            EmailName: FormikProps!.values.formDataModel.CorrespondenceName || "",
            RecipientCount: recipientCount,
            ToAddressTypeStrings: FormikProps!.values.formDataModel.EmailToItems.map((x) => x.label),
            CCAddressTypeStrings: FormikProps!.values.formDataModel.EmailCCAddressItems.map((x) => x.label),
            CCFirstOnly: FormikProps!.values.formDataModel.CCAddressOnlyFirst,
            EmailCC: FormikProps!.values.formDataModel.EmailCC,
            BCCAddressTypeStrings: FormikProps!.values.formDataModel.EmailBCCAddressItems.map((x) => x.label),
            BCCFirstOnly: FormikProps!.values.formDataModel.BCCAddressOnlyFirst,
            EmailBCC: FormikProps!.values.formDataModel.EmailBCC,
            Subject: FormikProps!.values.formDataModel.Preview?.subject || "",
            ViewOnPortal: FormikProps!.values.formDataModel.ViewOnWeb,
            CopyToCorrespondence: FormikProps!.values.formDataModel.CopyToCorrespondence,
            FromDescription: fromDesc,
            FromAddress: fromAddress,
        });

    }, [IsShown]);

    return (
        <PreviewDiv>
            <PreviewPanel
                Body={FormikProps!.values.formDataModel.Preview?.body! || ""}
            />
            <SummaryPanelDiv>
                <SummaryPanel {...summaryData}></SummaryPanel>
            </SummaryPanelDiv>
        </PreviewDiv>
    );
}, (prevProps, nextProps) => prevProps.IsShown === nextProps.IsShown);
